import "./styles/index.css";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import routes from "@/configs/configRotas/config-rotas";
import { env } from "@/configs/configEnv/env";
import { DataTableProvider } from "./contexts/DataTableContext";
import { setupStaleChunkReload } from "@/utils/storage/staleChunkReload";
import PwaInstallProvider from "@/contexts/pwaInstall/PwaInstallProvider";

// Recarrega automaticamente quando um chunk obsoleto falha após um novo deploy.
setupStaleChunkReload();

/**
 * The root element of the application.
 */
const container = document.getElementById("app");

if (!container) throw new Error("Failed to find the root element");

/**
 * The root component of the application.
 */
const root = createRoot(container, {
	onUncaughtError: (error, errorInfo) => {
		console.error("UncaughtError error", error, errorInfo.componentStack);
	},
	onCaughtError: (error, errorInfo) => {
		console.error("Caught error", error, errorInfo.componentStack);
	},
});

const bootstrap = async () => {
	if (import.meta.env.DEV && env.VITE_ENABLE_MOCKS) {
		const { worker } = await import("./mocks/browser");
		await worker.start({
			onUnhandledRequest: "bypass",
			serviceWorker: {
				url: `/mockServiceWorker.js`,
			},
		});
	}

	const router = createBrowserRouter(routes);
	root.render(
		<PwaInstallProvider>
			<DataTableProvider>
				<RouterProvider router={router} />
			</DataTableProvider>
		</PwaInstallProvider>,
	);
};

bootstrap();
